// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// const firebaseConfig = {
//   apiKey: "AIzaSyAmnoXhG7WQykblFaTKtnwpQ-phwvAGqCg",
//   authDomain: "foodie-7b397.firebaseapp.com",
//   projectId: "foodie-7b397",
//   storageBucket: "foodie-7b397.firebasestorage.app",
//   messagingSenderId: "977708840689",
//   appId: "1:977708840689:web:586b000f27496292849b50",
// };
const firebaseConfig = {
  apiKey: "AIzaSyC4iG7K-zWMrVupas4niPU5qYDoDhPgbn0",
  authDomain: "translation-app-93a58.firebaseapp.com",
  projectId: "translation-app-93a58",
  storageBucket: "translation-app-93a58.firebasestorage.app",
  messagingSenderId: "821987079517",
  appId: "1:821987079517:web:7e8c0966cd6d13c75064b4",
  measurementId: "G-B9B5RTVG6K",
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
export default app;
